import React from 'react';

import {useHistory} from 'react-router-dom';

import CloseImg from '../../../../../../../../../../assets/icons/addadminclose.svg';

import {AddStudentHeaderContainer} from './elements';

export const AddStudentHeader = () => {
  const history = useHistory();

  return (
    <AddStudentHeaderContainer>
      <div className="add-student-header">
        <div className="add-student-title">
          <div>
            <span className="add-student-name">Add Student</span>
          </div>
          <div>
            <button
              className="btn"
              id="closeBtn"
              onClick={() => {
                history.replace(`/admin/users/student`);
              }}
              type="button"
            >
              <img alt="Options" src={CloseImg} />
            </button>
          </div>
        </div>
      </div>
    </AddStudentHeaderContainer>
  );
};
